import React from 'react';
import { Check } from 'lucide-react';
import { ElementsRenderer } from '../shared';
import { StatusBadge } from '../ui/status-badge';
import { cn } from '../ui/utils';

const AssignmentReviewOption = (props) => {
  const { elements, isCorrect, studentSelected, isMultipleChoice } = props;

  let tagText = '';
  let tagVariant = 'default';

  if (studentSelected && isCorrect) {
    tagText = 'Your Answer';
    tagVariant = 'correct';
  } else if (!studentSelected && isCorrect) {
    tagText = 'Correct Answer';
    tagVariant = 'correct';
  } else if (studentSelected && !isCorrect) {
    tagText = 'Your Answer';
    tagVariant = 'incorrect';
  }

  const selected = studentSelected;

  return (
    <div
      className={cn(
        'flex items-start rounded-lg border p-4 transition-colors',
        selected ? 'border-primary bg-primary/5' : 'border-border',
        isCorrect && !selected && 'border-green-200 bg-green-50/50'
      )}
    >
      {isMultipleChoice ? (
        <div
          className={cn(
            'mr-3 mt-0.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-[4px] border',
            selected
              ? 'border-primary bg-primary text-primary-foreground'
              : 'border-muted-foreground bg-input-background'
          )}
          aria-hidden
        >
          {selected && <Check className="h-3 w-3" />}
        </div>
      ) : (
        <div
          className={cn(
            'mr-3 mt-0.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border-2',
            selected ? 'border-primary bg-primary' : 'border-muted-foreground'
          )}
          aria-hidden
        >
          {selected && <div className="h-2 w-2 rounded-full bg-white" />}
        </div>
      )}

      <div className="min-w-0 flex-1 leading-relaxed text-foreground">
        <ElementsRenderer elements={elements} />
      </div>

      {tagText && (
        <StatusBadge variant={tagVariant} className="ml-3 flex-shrink-0">
          {tagText}
        </StatusBadge>
      )}
    </div>
  );
};

export { AssignmentReviewOption };
